import { $api } from "../../../../../services/request.config";
import {
    setKnowledgeCategoriesAction,
    setKnowledgeErrorAction,
    setKnowledgeLoadingAction,
} from "../knowledgeActions";

export const getKnowledgeCategoriesThunk = () => async (dispatch) => {
    dispatch(setKnowledgeLoadingAction(true));
    try {
        const response = await $api.get("v1/knowledge-base/categories");
        if (response.status === 200) {
            dispatch(setKnowledgeCategoriesAction(response.data));
        }
    } catch (e) {
        dispatch(setKnowledgeErrorAction(e.message));
    } finally {
        dispatch(setKnowledgeLoadingAction(false));
    }
};